export default __webpack_public_path__ + "static/textile_library_logo-2a6f94cd54fe7287a946da5c44ee145c.png";